// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__2rJT1","title":"card_title__3B2Eh","inActive":"card_inActive__plqip"};